import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';

import {SmartadminValidationModule} from '../shared/forms/validation/smartadmin-validation.module';
import {SmartadminWidgetsModule} from '../shared/widgets/smartadmin-widgets.module';
import {SmartadminWizardsModule} from '../shared/forms/wizards/smartadmin-wizards.module';
import {SmartadminDatatableModule} from '../shared/ui/datatable/smartadmin-datatable.module';
import {SmartadminEditorsModule} from '../shared/forms/editors/smartadmin-editors.module';
import {SmartadminGalleryModule} from '../shared/ui/gallery/gallery.module';
import {SmartadminInputModule} from '../shared/forms/input/smartadmin-input.module';
import {SmartadminModule} from '../shared/smartadmin.module';
import {SmartadminLayoutModule} from '../shared/layout/layout.module';
import {I18nModule} from '../shared/i18n/i18n.module';

import {LoginComponent} from './views/login/login.component';
import {CategoryComponent} from './views/category/category.component';
import {UserProfileViewComponent} from './views/user-profile-view/user-profile-view.component';
import {LoginBannerComponent} from './components/login-banner/login-banner.component';

import {AppCommunicationService} from './services/app-communication.service';
import {SmartadminFormsLiteModule} from '../shared/forms/smartadmin-forms-lite.module';
import {UserRolePipe} from './pipes/user-role.pipe';
import {CustomPipesModule} from './pipes/customPipes.module';
import {TileComponent} from './components/tile/tile.component';
import {UserSearchComponent} from './components/user-search/user-search.component';
import {ExternalUserModalFormComponent} from './components/external-user-modal-form/external-user-modal-form.component';
import {AutoCompleteModule, CalendarModule, ConfirmDialogModule, PanelModule,DialogModule} from 'primeng/primeng';
import {AddIsbnViewComponent} from './views/add-isbn-view/add-isbn-view.component';
import {PublicationRegistrationViewComponent} from './views/publication-registration-view/publication-registration-view.component';
import {StepRegistrationDoneComponent} from './components/publication-registration/step-registration-done/step-registration-done.component';
import {StepNewPublicationComponent} from './components/publication-registration/step-new-publication/step-new-publication.component';
import {StepSummaryRegistrationComponent} from './components/publication-registration/step-summary-registration/step-summary-registration.component';
import {MyPublicationViewComponent} from './views/my-publication-view/my-publication-view.component';
import {DataTableModule} from 'primeng/components/datatable/datatable';
import {TableModule} from 'primeng/table';
import {AccordionModule, ModalModule} from 'ngx-bootstrap';
import {UserInformationFormPartComponent} from './components/publication-registration/base-publication-form-part/user-information-form-part/user-information-form-part.component';
import {PublicationInformationFormPartComponent} from './components/publication-registration/base-publication-form-part/publication-information-form-part/publication-information-form-part.component';
import {AuthorFormPartComponent} from './components/publication-registration/base-publication-form-part/author-form-part/author-form-part.component';
import {AuthorSummaryPartComponent} from './components/publication-registration/base-summary-form-part/author-summary-part/author-summary-part.component';
import {PublicationInformationSummaryPartComponent} from './components/publication-registration/base-summary-form-part/publication-information-summary-part/publication-information-summary-part.component';
import {UserInformationSummaryPartComponent} from './components/publication-registration/base-summary-form-part/user-information-summary-part/user-information-summary-part.component';
import {PublicationListViewComponent} from './views/publication-list-view/publication-list-view.component';
import {PublicationReviewViewComponent} from './views/publication-review-view/publication-review-view.component';
import {ConfirmationService} from 'primeng/api';
import {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
import {GenerateReportViewComponent} from './views/generate-report-view/generate-report-view.component';
import {ActionHistoryListViewComponent} from './views/action-history-list-view/action-history-list-view.component';
import {SupervisorsFormPartComponent} from './components/publication-registration/base-publication-form-part/supervisors-form-part/supervisors-form-part.component';
import {CheckboxModule} from 'primeng/checkbox';
import {StepBaseInformationComponent} from './components/publication-registration/step-base-information/step-base-information.component';
import {PrintsReportTableComponent} from './components/generate-report/prints-report-table/prints-report-table.component';
import {IsbnReportTableComponent} from './components/generate-report/isbn-report-table/isbn-report-table.component';
import { IsbnChangedReportTableComponent } from './components/generate-report/isbn-changed-report-table/isbn-changed-report-table.component';
import { DevComponent } from './components/dev/dev.component';
import { StatisticsViewComponent } from './views/statistics-view/statistics-view.component';
import {DashboardViewComponent} from './views/dashboard-view/dashboard-view.component';
import { FaqViewComponent } from './views/faq-view/faq-view.component';

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        HttpModule,
        SmartadminValidationModule,
        SmartadminFormsLiteModule,
        SmartadminWidgetsModule,
        SmartadminLayoutModule,
        SmartadminWizardsModule,
        SmartadminDatatableModule,
        SmartadminEditorsModule,
        SmartadminGalleryModule,
        SmartadminInputModule,
        AccordionModule.forRoot(),
        I18nModule,
        SmartadminModule,
        CustomPipesModule,
        AutoCompleteModule,
        CalendarModule,
        DataTableModule,
        TableModule,
        ModalModule.forRoot(),
        ConfirmDialogModule,
        NgMultiSelectDropDownModule.forRoot(),
        PanelModule,
        CheckboxModule,
        DialogModule,
    ],
    declarations: [
        LoginComponent,
        CategoryComponent,
        UserProfileViewComponent,
        LoginBannerComponent,
        DashboardViewComponent,
        TileComponent,
        UserSearchComponent,
        ExternalUserModalFormComponent,
        AddIsbnViewComponent,
        PublicationRegistrationViewComponent,
        StepRegistrationDoneComponent,
        StepNewPublicationComponent,
        StepSummaryRegistrationComponent,
        MyPublicationViewComponent,
        UserInformationFormPartComponent,
        PublicationInformationFormPartComponent,
        AuthorFormPartComponent,
        AuthorSummaryPartComponent,
        PublicationInformationSummaryPartComponent,
        UserInformationSummaryPartComponent,
        PublicationListViewComponent,
        PublicationReviewViewComponent,
        GenerateReportViewComponent,
        ActionHistoryListViewComponent,
        SupervisorsFormPartComponent,
        StepBaseInformationComponent,
        PrintsReportTableComponent,
        IsbnReportTableComponent,
        IsbnChangedReportTableComponent,
        DevComponent,
        StatisticsViewComponent,
        FaqViewComponent
    ],
    exports: [
        LoginComponent,
        CategoryComponent,
    ],
    providers: [
        AppCommunicationService,
        ConfirmationService,
        // {
        //     provide: HTTP_INTERCEPTORS,
        //     useClass: TokenInterceptor,
        //     multi: true
        // },

    ]
})

export class CustomModule {
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/custom.module.ts